









import {WConfTpl, WidgetDefinition} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {defineComponent} from "@vue/composition-api"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {executeQuery} from "@/data/repos/query"
import {format} from "date-fns"
import {reformatDate} from "@/data/sources/dates"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Text(),
    widget: "JobsRaisedFinancialYear",
    title: "Reactive jobs raised in current financial year",
    params: {},
  }
}

async function dataFetcher(params: any) {
  const dates = getDates()
  const r = await executeQuery(
    "FMS_DB",
    "jobsRaisedFinancialYear",
          {from: dates.from, to: dates.to})
  return {value: formatNumberWithGrouping(r[0].Value)}
}

function chartClickCallback() {
  bus.$emit('chartPopup', {
    title: config().title,
    component: () => import('@/components/drilldowns/JobsRaisedFinancialYearDrillDown.vue'),
    componentArgs: {
      ...getDates(),
      status: 2,
      hdPPMRepairAll: 2,
    },
  })
}

async function titleCallback(config: any) {
  const d = getDates()
  return `From: ${reformatDate(d.from)} to ${reformatDate(d.to)}`
}

function getDates(): { from: string, to: string } {
  const d = new Date()
  const year = d.getFullYear()
  let financialYearFrom
  let financialYearTo
  if (d <= new Date(year + '-03-31')) {
    financialYearFrom = (year - 1) + '-04-01'
    financialYearTo = (year) + '-03-31'
  } else {
    financialYearFrom = (year) + '-04-01'
    financialYearTo = (year + 1) + '-03-31'
  }
  return {from: financialYearFrom, to: financialYearTo}
}

export default defineComponent({
  props: {config: Object},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())
    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
